<div class="content-wrapper">
  @if (rates()) {
    <mat-card class="content">
      <div class="content-header">
        <h2>
          Alle tarieven <span>({{ totalRates() }})</span>
        </h2>
        <mat-form-field class="mat-form-field-no-subscript">
          <mat-label>Zoeken</mat-label>
          <input matInput autocomplete="off" placeholder="Zoeken" [formControl]="searchCtrl" />
          <button
            mat-icon-button
            matSuffix
            aria-label="Zoekopdracht wissen"
            (click)="clearSearch(); $event.stopPropagation()"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>
      <mat-table mat-table #table [dataSource]="filteredRates()">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>Naam</mat-header-cell>
          <mat-cell *matCellDef="let rate">
            @if (rate.name) {
              <p class="text-truncate">
                {{ rate.name }}
              </p>
            }
            @if (rate.default) {
              <mat-chip class="default-rate">standaard tarief</mat-chip>
            }
          </mat-cell>
        </ng-container>
        <!-- credits Column -->
        <ng-container matColumnDef="credits">
          <mat-header-cell *matHeaderCellDef>Aantal credits</mat-header-cell>
          <mat-cell *matCellDef="let rate">
            <p class="text-truncate">
              {{ rate.cost }}
            </p>
          </mat-cell>
        </ng-container>
        <!-- color Column -->
        <ng-container matColumnDef="color">
          <mat-header-cell class="hide-column" *matHeaderCellDef>Kleur</mat-header-cell>
          <mat-cell class="hide-column" *matCellDef="let rate">
            @if (rate.color) {
              <div
                class="color-dot"
                [ngStyle]="{
                  'background-color': rate.color.includes('#') ? rate.color : '#' + rate.color,
                }"
              ></div>
              <p class="text-truncate">
                {{ rate.color.includes('#') ? rate.color : '#' + rate.color }}
              </p>
            } @else {
              <div class="color-dot default-color"></div>
              <p class="text-truncate">#efefef</p>
            }
          </mat-cell>
        </ng-container>
        <!-- button Column -->
        <ng-container matColumnDef="button">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let rate">
            <div class="buttons">
              <button mat-icon-button aria-label="Tarief bewerken">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let rate; columns: displayedColumns"
          class="user"
          role="button"
          tabindex="0"
          aria-label="Tarief openen"
          (click)="editItem(rate)"
          (keydown.enter)="editItem(rate)"
          (keydown.space)="$event.preventDefault(); editItem(rate)"
          matRipple
        ></tr>
      </mat-table>
    </mat-card>
  } @else {
    <div class="content-spinner">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
